module.exports = __webpack_public_path__ + "img/HC1025-169.f9b6ae50.jpg";